import { render, staticRenderFns } from "./PostsListView.vue?vue&type=template&id=2dcddb03&lang=pug&"
import script from "./PostsListView.vue?vue&type=script&lang=js&"
export * from "./PostsListView.vue?vue&type=script&lang=js&"
import style0 from "./PostsListView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports